import postalSaudeLogo from 'presentation/assets/images/logo-postal-saude.webp';
import {PartnerLogoConfig} from './types';

export const PARTNER_LOGO_MAP: Record<string, PartnerLogoConfig> = {
	'1': {
		logo: postalSaudeLogo,
		alt: 'Logo da empresa parceira Postal Saúde',
	},
};
